export default {
    "fit": "fit",
    "flip": "flip",
    "none": "none"
};
